/* 全部作品 */
import React, { useState, useEffect } from 'react'
import { Input, Button, Checkbox, message, Select, Pagination, Spin } from 'antd';
import { SearchOutlined , UndoOutlined } from '@ant-design/icons';
import { listCourse } from "../../../../http/modules/province";
import { courseCategoryList } from '../../../../http/modules/organization'
import ReviewWorks from './reviewWorks'
import DownLoad from '../../../../components/ossUpload/download'
import './index.scss'
const { Search } = Input;

export default function Index() {

  const [selectdType, setSelectdType] = useState([
    // 'qiyeweike/BeiJing/政策解读类/优质中小企业梯度培育政策解读/',
  ])
  //全部课程类别
  const [categoryList, setCategoryList] = useState([])
  // 作品数量  分页器总数
  const [number, setNumber] = useState(0)
  // 已审核数量
  const [audited, setAudited] = useState(0)
  // 未审核数量
  const [unreviewed, setUnreviewed] = useState(0)
  // 分页器  当前页数
  const [current, setCurrent] = useState(1)
  // 课程信息
  const [info, setInfo] = useState()
  // 课程类别选择
  const [categorySelect, setCategorySelect] = useState()
  // 评审状态选择
  const [auditStateSelect, setAuditStateSelect] = useState()

  // 审核作品
  const [reviewWorks, setReviewWorks] = useState(false)
  // 审核作品id
  const [reviewWorksId, setReviewWorksId] = useState(false)
  // loding
  const [loading,setLoading] = useState(false)

  // 搜索按钮
  const onSearch = async (value) => {
    onListCourse(1, '', '', value)
  };

  // 下拉课程类别
  const handleChange = (value) => {
    setCategorySelect(value)
  };
  // 下拉评审状态
  const handleChange2 = (value) => {
    setAuditStateSelect(value)
  };

  // 复选框点击
  const onChange = (e, item) => {
    let types = [...selectdType]
    if (e.target.checked) {
      let url = decodeURI(item.formCourseUrl)
      const index = url.lastIndexOf("qiyeweike")
      const res = url.substring(index, url.length)
      let a = res.lastIndexOf("\/")
      let b = res.substring(0, a + 1);
      types.push(b)
    } else {
      let url = decodeURI(item.formCourseUrl)
      const index = url.lastIndexOf("qiyeweike")
      const res = url.substring(index, url.length)
      let a = res.lastIndexOf("\/")
      let b = res.substring(0, a + 1);
      types.splice(types.findIndex(item => item == b), 1)
    }
    setSelectdType(types)
  };

  // 分页器点击回调
  const onPagination = (page) => {
    onListCourse(page)
  }

  // 课程列表
  const onListCourse = async (page, category = '', auditState = '', searchTxt = '') => {
    setLoading(true)
    try {
      const res = await listCourse({
        "pageNo": page,
        "pageSize": 12,
        "category": category, // 课程类别
        "auditState": auditState, // 评审状态
        "searchTxt": searchTxt // 课程名称 授课人 申报单位 搜索
      });
      if (res.code == 0) {
        setCurrent(res.data.pageNo)
        setNumber(res.data.total)
        setAudited(res.data.cntProvinceAuditYes)
        setUnreviewed(res.data.cntProvinceAuditNo)
        setInfo(res.data.list)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      message.error(err.response.data?.msg);
    }
  };

  //课程类别
  const onCourseCategoryList = async () => {
    const res = await courseCategoryList({})
    setCategoryList(res.data?.list)
  }

  useEffect(() => {
    onCourseCategoryList()
    onListCourse(1)
  }, [])

  return (
    <Spin spinning={loading}>
      {reviewWorks ? <ReviewWorks setReviewWorks={setReviewWorks} reviewWorksId={reviewWorksId} /> : <div className='oeuvre'>
        <header>
          <Search
            placeholder="请输入课程名称/授课人/申报单位"
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={onSearch}
          />
          <div className='headerButton'>
            {/* <Button shape="round" onClick={download} icon={<DownloadOutlined style={{ fontSize: '23px', fontWeight: 'bold' }} />} size={'large'}>
          下载
        </Button> */}
            <DownLoad selectdType={selectdType} setSelectdType={setSelectdType}></DownLoad>
          </div>
        </header>
        <div className='filter'>
          <div className='p'>
            课程类别：
            <Select
              value={categorySelect}
              defaultValue="全部"
              style={{ width: 300 }}
              onChange={handleChange}
              options={categoryList.map(item => ({ value: item.name, label: item.name }))}
            />
          </div>
          <div className='p'>
            评审状态：
            <Select
              value={auditStateSelect}
              defaultValue="全部"
              style={{ width: 300 }}
              onChange={handleChange2}
              options={[
                {
                  value: '已评审',
                  label: '已评审',
                },
                {
                  value: '未评审',
                  label: '未评审',
                }
              ]}
            />
          </div>
          <div className='p'>
            <Button type="primary" onClick={() => { onListCourse(1, categorySelect, auditStateSelect, '') }} shape="round" icon={<SearchOutlined  />} size={'large'}>
              查询
            </Button>
            <Button onClick={() => { setCategorySelect('全部'); setAuditStateSelect('全部') }} style={{ background: '#FFFFFF', color: '#1F78FE' }} type="primary" shape="round" icon={<UndoOutlined />} size={'large'}>
              重置
            </Button>
          </div>
        </div>
        <div className='tongJi'>
          <p>共有 <span>{number}</span> 个作品</p>
          <p>已评审 <span>{audited}</span> 个作品</p>
          <p>未评审 <span>{unreviewed}</span> 个作品</p>
        </div>
        <main>

          {info?.map((item, index) => {
            return <div key={index}>
              <div className='divHeader'>
                <video src={item.mainCourseUrl} controls muted preload='none'></video>
              </div>
              <div className='divFooter'>
                <p title={item.title}> {item.title} </p>
                <p>
                  <span onClick={() => { setReviewWorks(true); setReviewWorksId(item.courseUUID) }} style={{ margin: '0 20px' }}>审核</span>
                  {/* <span>下载</span> */}
                  <Checkbox onChange={(e) => onChange(e, item)}></Checkbox>
                </p>
              </div>
            </div>
          })}

        </main>
        <footer>
          <Pagination onChange={onPagination} total={number} current={current} pageSize={12} />
        </footer>
      </div>}
    </Spin>
  )
}
